// SPDX-License-Identifier: AGPL-3.0-or-later

import {SettingsSection} from '@app/features/app/components/dialogs/shared/SettingsSection';
import {ActiveNowTabContent as ActiveNowTab} from '@app/features/user/components/modals/tabs/privacy_safety_tab/ActiveNowTab';
import {CommunicationTabContent as CommunicationTab} from '@app/features/user/components/modals/tabs/privacy_safety_tab/CommunicationTab';
import {ConnectionsTabContent as ConnectionsTab} from '@app/features/user/components/modals/tabs/privacy_safety_tab/ConnectionsTab';
import {DataDeletionTabContent as DataDeletionTab} from '@app/features/user/components/modals/tabs/privacy_safety_tab/DataDeletionTab';
import {DataExportTabContent as DataExportTab} from '@app/features/user/components/modals/tabs/privacy_safety_tab/DataExportTab';
import {MentionPreferenceTabContent as MentionPreferenceTab} from '@app/features/user/components/modals/tabs/privacy_safety_tab/MentionPreferenceTab';
import styles from '@app/features/user/components/modals/tabs/privacy_safety_tab/PrivacySafetyTabInline.module.css';
import {ProfilePrivacyTabContent as ProfilePrivacyTab} from '@app/features/user/components/modals/tabs/privacy_safety_tab/ProfilePrivacyTab';
import {SensitiveContentTabContent as SensitiveContentTab} from '@app/features/user/components/modals/tabs/privacy_safety_tab/SensitiveContentTab';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';

const CONNECTIONS_DESCRIPTOR = msg({
	message: 'Connections',
	comment: 'Short label in the inline. Keep it concise.',
});
const PROFILE_PRIVACY_DESCRIPTOR = msg({
	message: 'Profile privacy',
	comment: 'Privacy & safety settings inline section label for who can see the user profile details.',
});
const COMMUNICATION_DESCRIPTOR = msg({
	message: 'Communication',
	comment: 'Short label in the inline. Keep it concise.',
});
const ACTIVE_NOW_DESCRIPTOR = msg({
	message: 'Active now',
	comment: 'Privacy & safety settings inline section label for voice activity sharing.',
});
const MENTION_PREFERENCE_DESCRIPTOR = msg({
	message: 'Mention preference',
	comment: 'Short label in the inline. Keep it concise.',
});
const SENSITIVE_CONTENT_DESCRIPTOR = msg({
	message: 'Sensitive content',
	comment: 'Short label in the inline. Keep it concise.',
});
const DATA_EXPORT_DESCRIPTOR = msg({
	message: 'Data export',
	comment: 'Short label in the inline. Keep it concise.',
});
const DATA_DELETION_DESCRIPTOR = msg({
	message: 'Data deletion',
	comment: 'Short label in the inline. Keep it concise.',
});
export const PrivacySafetyInlineContent: React.FC = observer(() => {
	const {i18n} = useLingui();
	return (
		<div className={styles.container} data-flx="user.privacy-safety-tab.inline.privacy-safety-inline-content.container">
			<SettingsSection
				id="profile-privacy"
				title={i18n._(PROFILE_PRIVACY_DESCRIPTOR)}
				data-flx="user.privacy-safety-tab.inline.privacy-safety-inline-content.profile-privacy"
			>
				<ProfilePrivacyTab data-flx="user.privacy-safety-tab.inline.privacy-safety-inline-content.profile-privacy-tab" />
			</SettingsSection>
			<SettingsSection
				id="connections"
				title={i18n._(CONNECTIONS_DESCRIPTOR)}
				data-flx="user.privacy-safety-tab.inline.privacy-safety-inline-content.connections"
			>
				<ConnectionsTab data-flx="user.privacy-safety-tab.inline.privacy-safety-inline-content.connections-tab" />
			</SettingsSection>
			<SettingsSection
				id="communication"
				title={i18n._(COMMUNICATION_DESCRIPTOR)}
				data-flx="user.privacy-safety-tab.inline.privacy-safety-inline-content.communication"
			>
				<CommunicationTab data-flx="user.privacy-safety-tab.inline.privacy-safety-inline-content.communication-tab" />
			</SettingsSection>
			<SettingsSection
				id="active-now"
				tabType="privacy_safety"
				title={i18n._(ACTIVE_NOW_DESCRIPTOR)}
				data-flx="user.privacy-safety-tab.inline.privacy-safety-inline-content.active-now"
			>
				<ActiveNowTab data-flx="user.privacy-safety-tab.inline.privacy-safety-inline-content.active-now-tab" />
			</SettingsSection>
			<SettingsSection
				id="mention-preference"
				title={i18n._(MENTION_PREFERENCE_DESCRIPTOR)}
				data-flx="user.privacy-safety-tab.inline.privacy-safety-inline-content.mention-preference"
			>
				<MentionPreferenceTab data-flx="user.privacy-safety-tab.inline.privacy-safety-inline-content.mention-preference-tab" />
			</SettingsSection>
			<SettingsSection
				id="sensitive-content"
				title={i18n._(SENSITIVE_CONTENT_DESCRIPTOR)}
				data-flx="user.privacy-safety-tab.inline.privacy-safety-inline-content.sensitive-content"
			>
				<SensitiveContentTab data-flx="user.privacy-safety-tab.inline.privacy-safety-inline-content.sensitive-content-tab" />
			</SettingsSection>
			<SettingsSection
				id="data-export"
				title={i18n._(DATA_EXPORT_DESCRIPTOR)}
				data-flx="user.privacy-safety-tab.inline.privacy-safety-inline-content.data-export"
			>
				<DataExportTab data-flx="user.privacy-safety-tab.inline.privacy-safety-inline-content.data-export-tab" />
			</SettingsSection>
			<SettingsSection
				id="data-deletion"
				title={i18n._(DATA_DELETION_DESCRIPTOR)}
				data-flx="user.privacy-safety-tab.inline.privacy-safety-inline-content.data-deletion"
			>
				<DataDeletionTab data-flx="user.privacy-safety-tab.inline.privacy-safety-inline-content.data-deletion-tab" />
			</SettingsSection>
		</div>
	);
});
